/* eslint-disable @next/next/no-img-element */
/* eslint-disable @next/next/no-html-link-for-pages */
import React, { FC, useContext, useEffect, useState } from "react";
import cx from "classnames";
import { endpoints } from "config";
import {
  getSdk,
  mainFooterQuery,
  mainHeaderQuery,
} from "services/datocms/generated";
import { createDatoClient } from "services/datocms";
import { useRouter } from "next/router";
import { BodyClassContext } from "context/bodyClass";
import { UserContext } from "context/user";
import Link from "next/link";
import st from "./index.module.scss";
import { useIsMobile } from "@pepdirect/helpers/useIsMobile";
import { LogoHorizontalSvg } from "components/logos";

const RockstarHeader: FC = () => {
  const router = useRouter();
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [header, setHeader] = useState<mainHeaderQuery["mainHeader"]>(null);
  const [isSticky, setIsSticky] = useState<boolean>(false);
  const { addClass, removeClass, bodyClass } = useContext(BodyClassContext);
  const [footer, setFooter] = useState<mainFooterQuery["mainFooter"]>(null);
  const { currentUserId } = useContext(UserContext);
  const accountUrl = currentUserId
    ? `${endpoints.checkout}/dashboard/account`
    : "/sign-in";
  const isHomepage = router?.pathname === "/";
  const isFocusLandingPage = router?.pathname === "/focus";
  const isWhiteBg = bodyClass.includes("whitebg");
  const isDark = !isSticky && isWhiteBg;
  const isMobile = useIsMobile();

  useEffect(() => {
    getSdk(createDatoClient(router?.isPreview))
      .mainHeader()
      .then((res) => {
        setHeader(res.mainHeader);
      });

    getSdk(createDatoClient(router?.isPreview))
      .mainFooter()
      .then((res) => {
        setFooter(res.mainFooter);
      });
  }, [router?.isPreview]);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 140 ? !isWhiteBg : false);
    };
    handleScroll();

    document.addEventListener("scroll", handleScroll.bind(this));
    return document.removeEventListener("scroll", handleScroll.bind(this));
  }, [isWhiteBg]);

  useEffect(() => {
    if (isSticky) {
      addClass("sticky-menu");
    } else {
      removeClass("sticky-menu");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSticky]);

  useEffect(() => {
    if (menuOpen) {
      addClass("nav-open scroll-lock");
    } else {
      removeClass("nav-open scroll-lock");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuOpen]);

  return (
    <>
      <header
        id="masthead"
        className={cx(
          st.siteHeader,
          menuOpen && st.navOpen,
          !menuOpen && st.notNavOpen,
          !isHomepage && st.notHome,
          isDark && st.dark,
          isSticky && st.stickyHeader,
          isFocusLandingPage && st.focus
        )}
        role="banner"
      >
        <div className={st.headerContent}>
          <div className={st.headerLeft}>
            <div className={cx(st.siteBranding, menuOpen && st.navopen)}>
              <div
                className={cx(
                  st.siteLogo,
                  isHomepage && st.home,
                  isDark && st.dark,
                  menuOpen && st.navopen
                )}
              >
                {" "}
                <Link href="/">
                  <a href="/" title="Rockstar">
                    <LogoHorizontalSvg />
                  </a>
                </Link>
              </div>

              <div
                className={cx(
                  st.siteLogo,
                  st.homeSiteLogo,
                  isHomepage && st.home,
                  isDark && st.dark,
                  menuOpen && st.navopen
                )}
              >
                <LogoHorizontalSvg />
              </div>

              <p className="screen-reader-text">
                <Link href="/">
                  <a href="/">Rockstar Energy</a>
                </Link>
              </p>
            </div>

            <div className={cx(st.headerLeftCart, menuOpen && st.navopen)}>
              <Link href="/cart">
                <a href="/cart" title="cart">
                  <svg
                    className="svg-icon"
                    width="62"
                    height="30"
                    viewBox="0 0 62 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.8795 29H43.8697H47.8088C55.0941 29 61 23.028 61 15.6612V14.3388C61 6.97196 55.0941 1 47.8088 1H14.1924C6.9059 1 1 6.97195 1 14.3388V15.6612C1 23.028 6.90591 29 14.1924 29H18.1314H36.194H37.834C37.9975 28.0946 38.1599 27.1892 38.3244 26.2838C38.3782 25.9873 38.3825 25.9873 38.0766 25.9873C32.5577 25.9873 27.0399 25.9831 21.521 25.9937C20.8133 25.9948 20.4463 25.7314 20.1869 25.0926C19.4686 23.3266 18.7431 21.5628 18.0165 19.8C17.4122 18.3326 16.8005 16.8673 16.1951 15.3999C15.7628 14.3548 15.3324 13.3086 14.9064 12.2614C14.5963 11.5 15.0899 10.7236 15.9093 10.6735C16.0021 10.6682 16.0959 10.6714 16.1899 10.6714C20.2713 10.6714 24.3516 10.6714 28.433 10.6714C32.5577 10.6714 36.6824 10.6714 40.806 10.6714C41.1266 10.6714 41.1288 10.6714 41.1867 10.3493C41.3618 9.37782 41.5369 8.4063 41.7056 7.4348C41.771 7.0637 41.9017 6.73737 42.2245 6.51768C42.3965 6.40145 42.582 6.34065 42.7908 6.34173C44.6164 6.34386 46.4409 6.34065 48.2664 6.34386C48.7716 6.34492 49.2124 6.71604 49.3 7.19593C49.4044 7.76754 49.1291 8.29648 48.625 8.48737C48.4267 8.56203 48.2211 8.58335 48.0113 8.58335C46.7099 8.58229 45.4095 8.58335 44.1091 8.58335C43.7684 8.58335 43.7664 8.58335 43.7073 8.91181C43.3193 11.0617 42.9332 13.2116 42.544 15.3615C42.2624 16.9174 41.9756 18.4733 41.6941 20.0303C41.3766 21.7867 41.0612 23.5442 40.7459 25.3016C40.5234 26.5344 40.2998 27.7672 40.0794 29L41.8795 29Z"
                      stroke="white"
                    />
                  </svg>
                </a>
              </Link>
            </div>
            <div className={cx(st.headerLeftCart, menuOpen && st.navopen)}>
              <a href={accountUrl} title="account">
                <svg
                  width="59"
                  height="29"
                  viewBox="0 0 59 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M45.7493 1.39941H13.8733C6.96533 1.39941 1.36523 6.9994 1.36523 13.9074V15.1474C1.36523 22.0554 6.96533 27.6554 13.8733 27.6554H17.6083C18.1243 23.4284 21.1373 19.9474 25.1223 18.7504C23.8493 17.5214 23.0543 15.8004 23.0543 13.8914C23.0543 10.1594 26.0792 7.13443 29.8113 7.13443C33.5434 7.13443 36.5683 10.1594 36.5683 13.8914C36.5683 15.8004 35.7733 17.5214 34.5003 18.7504C38.4843 19.9474 41.4983 23.4284 42.0143 27.6554H45.7493C52.6573 27.6554 58.2574 22.0554 58.2574 15.1474V13.9074C58.2574 6.99941 52.6573 1.39941 45.7493 1.39941L45.7493 1.39941Z"
                    stroke="white"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div className={st.headerRight}>
            <Link href="/shop-all">
              <a
                className={cx(
                  st.btnLink,
                  menuOpen && st.navopen,
                  isDark && st.dark,
                  isHomepage && st.home
                )}
                href="/shop-all"
              >
                <span>{isMobile ? "Shop" : "Shop All"}</span>
              </a>
            </Link>
            <div
              className={cx(
                st.headerRightCart,
                menuOpen && st.navopen,
                isDark && st.dark
              )}
            >
              <Link href="/cart">
                <a href="/cart" title="cart">
                  <svg
                    className="svg-icon"
                    width="62"
                    height="30"
                    viewBox="0 0 62 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M41.8795 29H43.8697H47.8088C55.0941 29 61 23.028 61 15.6612V14.3388C61 6.97196 55.0941 1 47.8088 1H14.1924C6.9059 1 1 6.97195 1 14.3388V15.6612C1 23.028 6.90591 29 14.1924 29H18.1314H36.194H37.834C37.9975 28.0946 38.1599 27.1892 38.3244 26.2838C38.3782 25.9873 38.3825 25.9873 38.0766 25.9873C32.5577 25.9873 27.0399 25.9831 21.521 25.9937C20.8133 25.9948 20.4463 25.7314 20.1869 25.0926C19.4686 23.3266 18.7431 21.5628 18.0165 19.8C17.4122 18.3326 16.8005 16.8673 16.1951 15.3999C15.7628 14.3548 15.3324 13.3086 14.9064 12.2614C14.5963 11.5 15.0899 10.7236 15.9093 10.6735C16.0021 10.6682 16.0959 10.6714 16.1899 10.6714C20.2713 10.6714 24.3516 10.6714 28.433 10.6714C32.5577 10.6714 36.6824 10.6714 40.806 10.6714C41.1266 10.6714 41.1288 10.6714 41.1867 10.3493C41.3618 9.37782 41.5369 8.4063 41.7056 7.4348C41.771 7.0637 41.9017 6.73737 42.2245 6.51768C42.3965 6.40145 42.582 6.34065 42.7908 6.34173C44.6164 6.34386 46.4409 6.34065 48.2664 6.34386C48.7716 6.34492 49.2124 6.71604 49.3 7.19593C49.4044 7.76754 49.1291 8.29648 48.625 8.48737C48.4267 8.56203 48.2211 8.58335 48.0113 8.58335C46.7099 8.58229 45.4095 8.58335 44.1091 8.58335C43.7684 8.58335 43.7664 8.58335 43.7073 8.91181C43.3193 11.0617 42.9332 13.2116 42.544 15.3615C42.2624 16.9174 41.9756 18.4733 41.6941 20.0303C41.3766 21.7867 41.0612 23.5442 40.7459 25.3016C40.5234 26.5344 40.2998 27.7672 40.0794 29L41.8795 29Z"
                      stroke="white"
                    />
                  </svg>
                </a>
              </Link>
            </div>

            <div
              className={cx(
                st.headerRightProfile,
                menuOpen && st.navopen,
                isDark && st.dark
              )}
            >
              <a href={accountUrl} title="account">
                <svg
                  width="59"
                  height="29"
                  viewBox="0 0 59 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M45.7493 1.39941H13.8733C6.96533 1.39941 1.36523 6.9994 1.36523 13.9074V15.1474C1.36523 22.0554 6.96533 27.6554 13.8733 27.6554H17.6083C18.1243 23.4284 21.1373 19.9474 25.1223 18.7504C23.8493 17.5214 23.0543 15.8004 23.0543 13.8914C23.0543 10.1594 26.0792 7.13443 29.8113 7.13443C33.5434 7.13443 36.5683 10.1594 36.5683 13.8914C36.5683 15.8004 35.7733 17.5214 34.5003 18.7504C38.4843 19.9474 41.4983 23.4284 42.0143 27.6554H45.7493C52.6573 27.6554 58.2574 22.0554 58.2574 15.1474V13.9074C58.2574 6.99941 52.6573 1.39941 45.7493 1.39941L45.7493 1.39941Z"
                    stroke="white"
                  />
                </svg>
              </a>
            </div>

            <nav
              className={st.primaryNavigation}
              role="navigation"
              aria-label="Primary menu"
            >
              <div>
                <button
                  className={st.menuButton}
                  aria-label="Primary Menu"
                  aria-controls="primary-menu-list"
                  onClick={() => setMenuOpen((prev) => !prev)}
                >
                  {!menuOpen ? (
                    <span className={cx(st.dropdownIcon, isDark && st.dark)}>
                      <svg
                        className={st.menuIcon}
                        width="59"
                        height="29"
                        viewBox="0 0 59 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M45.2102 0.898926H13.3352V1.89893H45.2102V0.898926ZM13.3352 0.898926C6.15103 0.898926 0.326172 6.72272 0.326172 13.9069H1.32617C1.32617 7.27511 6.70321 1.89893 13.3352 1.89893V0.898926ZM0.326172 13.9069V15.1469H1.32617V13.9069H0.326172ZM0.326172 15.1469C0.326172 22.3311 6.15103 28.1549 13.3352 28.1549V27.1549C6.70321 27.1549 1.32617 21.7787 1.32617 15.1469H0.326172ZM13.3352 28.1549H45.2102V27.1549H13.3352V28.1549ZM45.2102 28.1549C52.3943 28.1549 58.2181 22.3311 58.2181 15.1469H57.2181C57.2181 21.7788 51.842 27.1549 45.2102 27.1549V28.1549ZM58.2181 15.1469V13.9069H57.2181V15.1469H58.2181ZM58.2181 13.9069C58.2181 6.72279 52.3943 0.898926 45.2102 0.898926V1.89893C51.842 1.89893 57.2181 7.27507 57.2181 13.9069H58.2181ZM41.8922 21.3019H16.6532V22.3019H41.8922V21.3019ZM16.6532 21.3019C16.3763 21.3019 16.1532 21.0788 16.1532 20.8019H15.1532C15.1532 21.631 15.8239 22.3019 16.6532 22.3019V21.3019ZM16.1532 20.8019C16.1532 20.5257 16.3766 20.3019 16.6532 20.3019V19.3019C15.8236 19.3019 15.1532 19.9741 15.1532 20.8019H16.1532ZM16.6532 20.3019H41.8922V19.3019H16.6532V20.3019ZM41.8922 20.3019C42.1687 20.3019 42.3922 20.5257 42.3922 20.8019H43.3922C43.3922 19.9741 42.7217 19.3019 41.8922 19.3019V20.3019ZM42.3922 20.8019C42.3922 21.0788 42.1691 21.3019 41.8922 21.3019V22.3019C42.7213 22.3019 43.3922 21.6311 43.3922 20.8019H42.3922ZM41.8922 15.0269H16.6532V16.0269H41.8922V15.0269ZM16.6532 15.0269C16.3766 15.0269 16.1532 14.8031 16.1532 14.5269H15.1532C15.1532 15.3547 15.8236 16.0269 16.6532 16.0269V15.0269ZM16.1532 14.5269C16.1532 14.2507 16.3766 14.0269 16.6532 14.0269V13.0269C15.8236 13.0269 15.1532 13.6991 15.1532 14.5269H16.1532ZM16.6532 14.0269H41.8922V13.0269H16.6532V14.0269ZM41.8922 14.0269C42.1687 14.0269 42.3922 14.2507 42.3922 14.5269H43.3922C43.3922 13.6991 42.7217 13.0269 41.8922 13.0269V14.0269ZM42.3922 14.5269C42.3922 14.8031 42.1687 15.0269 41.8922 15.0269V16.0269C42.7217 16.0269 43.3922 15.3547 43.3922 14.5269H42.3922ZM41.8922 8.75193H16.6532V9.75193H41.8922V8.75193ZM16.6532 8.75193C16.3766 8.75193 16.1532 8.52814 16.1532 8.25193H15.1532C15.1532 9.07971 15.8236 9.75193 16.6532 9.75193V8.75193ZM16.1532 8.25193C16.1532 7.97504 16.3763 7.75193 16.6532 7.75193V6.75193C15.8239 6.75193 15.1532 7.42283 15.1532 8.25193H16.1532ZM16.6532 7.75193H41.8922V6.75193H16.6532V7.75193ZM41.8922 7.75193C42.1691 7.75193 42.3922 7.97508 42.3922 8.25193H43.3922C43.3922 7.42279 42.7213 6.75193 41.8922 6.75193V7.75193ZM42.3922 8.25193C42.3922 8.5281 42.1687 8.75193 41.8922 8.75193V9.75193C42.7217 9.75193 43.3922 9.07975 43.3922 8.25193H42.3922Z"
                          fill="white"
                        />
                      </svg>
                      <svg
                        className={st.menuIconHover}
                        width="59"
                        height="29"
                        viewBox="0 0 59 29"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M45.2102 1.39893H13.3352C6.42712 1.39893 0.826172 6.99892 0.826172 13.9069V15.1469C0.826172 22.0549 6.42712 27.6549 13.3352 27.6549H45.2102C52.1182 27.6549 57.7181 22.0549 57.7181 15.1469V13.9069C57.7181 6.99893 52.1182 1.39893 45.2102 1.39893ZM41.8922 21.8019H16.6532C16.1001 21.8019 15.6532 21.3549 15.6532 20.8019C15.6532 20.2499 16.1001 19.8019 16.6532 19.8019H41.8922C42.4452 19.8019 42.8922 20.2499 42.8922 20.8019C42.8922 21.3549 42.4452 21.8019 41.8922 21.8019ZM41.8922 15.5269H16.6532C16.1001 15.5269 15.6532 15.0789 15.6532 14.5269C15.6532 13.9749 16.1001 13.5269 16.6532 13.5269H41.8922C42.4452 13.5269 42.8922 13.9749 42.8922 14.5269C42.8922 15.0789 42.4452 15.5269 41.8922 15.5269ZM41.8922 9.25193H16.6532C16.1001 9.25193 15.6532 8.80393 15.6532 8.25193C15.6532 7.69894 16.1001 7.25193 16.6532 7.25193H41.8922C42.4452 7.25193 42.8922 7.69894 42.8922 8.25193C42.8922 8.80393 42.4452 9.25193 41.8922 9.25193Z"
                          fill="white"
                        />
                        <path
                          d="M45.2102 0.898926H13.3352V1.89893H45.2102V0.898926ZM13.3352 0.898926C6.15103 0.898926 0.326172 6.72272 0.326172 13.9069H1.32617C1.32617 7.27511 6.70321 1.89893 13.3352 1.89893V0.898926ZM0.326172 13.9069V15.1469H1.32617V13.9069H0.326172ZM0.326172 15.1469C0.326172 22.3311 6.15103 28.1549 13.3352 28.1549V27.1549C6.70321 27.1549 1.32617 21.7787 1.32617 15.1469H0.326172ZM13.3352 28.1549H45.2102V27.1549H13.3352V28.1549ZM45.2102 28.1549C52.3943 28.1549 58.2181 22.3311 58.2181 15.1469H57.2181C57.2181 21.7788 51.842 27.1549 45.2102 27.1549V28.1549ZM58.2181 15.1469V13.9069H57.2181V15.1469H58.2181ZM58.2181 13.9069C58.2181 6.72279 52.3943 0.898926 45.2102 0.898926V1.89893C51.842 1.89893 57.2181 7.27507 57.2181 13.9069H58.2181ZM41.8922 21.3019H16.6532V22.3019H41.8922V21.3019ZM16.6532 21.3019C16.3763 21.3019 16.1532 21.0788 16.1532 20.8019H15.1532C15.1532 21.631 15.8239 22.3019 16.6532 22.3019V21.3019ZM16.1532 20.8019C16.1532 20.5257 16.3766 20.3019 16.6532 20.3019V19.3019C15.8236 19.3019 15.1532 19.9741 15.1532 20.8019H16.1532ZM16.6532 20.3019H41.8922V19.3019H16.6532V20.3019ZM41.8922 20.3019C42.1687 20.3019 42.3922 20.5257 42.3922 20.8019H43.3922C43.3922 19.9741 42.7217 19.3019 41.8922 19.3019V20.3019ZM42.3922 20.8019C42.3922 21.0788 42.1691 21.3019 41.8922 21.3019V22.3019C42.7213 22.3019 43.3922 21.6311 43.3922 20.8019H42.3922ZM41.8922 15.0269H16.6532V16.0269H41.8922V15.0269ZM16.6532 15.0269C16.3766 15.0269 16.1532 14.8031 16.1532 14.5269H15.1532C15.1532 15.3547 15.8236 16.0269 16.6532 16.0269V15.0269ZM16.1532 14.5269C16.1532 14.2507 16.3766 14.0269 16.6532 14.0269V13.0269C15.8236 13.0269 15.1532 13.6991 15.1532 14.5269H16.1532ZM16.6532 14.0269H41.8922V13.0269H16.6532V14.0269ZM41.8922 14.0269C42.1687 14.0269 42.3922 14.2507 42.3922 14.5269H43.3922C43.3922 13.6991 42.7217 13.0269 41.8922 13.0269V14.0269ZM42.3922 14.5269C42.3922 14.8031 42.1687 15.0269 41.8922 15.0269V16.0269C42.7217 16.0269 43.3922 15.3547 43.3922 14.5269H42.3922ZM41.8922 8.75193H16.6532V9.75193H41.8922V8.75193ZM16.6532 8.75193C16.3766 8.75193 16.1532 8.52814 16.1532 8.25193H15.1532C15.1532 9.07971 15.8236 9.75193 16.6532 9.75193V8.75193ZM16.1532 8.25193C16.1532 7.97504 16.3763 7.75193 16.6532 7.75193V6.75193C15.8239 6.75193 15.1532 7.42283 15.1532 8.25193H16.1532ZM16.6532 7.75193H41.8922V6.75193H16.6532V7.75193ZM41.8922 7.75193C42.1691 7.75193 42.3922 7.97508 42.3922 8.25193H43.3922C43.3922 7.42279 42.7213 6.75193 41.8922 6.75193V7.75193ZM42.3922 8.25193C42.3922 8.5281 42.1687 8.75193 41.8922 8.75193V9.75193C42.7217 9.75193 43.3922 9.07975 43.3922 8.25193H42.3922Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  ) : (
                    <span className={cx(st.dropdownIcon)}>
                      <svg
                        className={st.menuIcon}
                        width="62"
                        height="30"
                        viewBox="0 0 62 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.3771 29L48.6229 29C55.4582 29 61 22.7317 61 14.9996C61 7.26748 55.4589 1.00001 48.6229 1.00001L13.3771 1C6.54109 1 1 7.26747 1 14.9996C0.999256 22.7317 6.54109 29 13.3771 29Z"
                          stroke="black"
                          strokeMiterlimit="10"
                        />
                        <path
                          d="M22.4233 9.69455L29.4142 14.5L22.4233 19.3054C22.1109 19.5204 21.9321 20.2848 22.0242 21.0133C22.1162 21.7418 22.4443 22.1584 22.7567 21.9434L31.4998 15.9335L40.2433 21.9434C40.5557 22.1584 40.8838 21.7418 40.9758 21.0133C41.0679 20.2848 40.8891 19.5196 40.5767 19.3055L33.5858 14.5L40.5767 9.69455C40.8891 9.4796 41.0679 8.71517 40.9758 7.9867C40.8838 7.25822 40.5557 6.84161 40.2433 7.05656L31.5002 13.0665L22.7571 7.05656C22.4447 6.84161 22.1166 7.25822 22.0246 7.98669C21.9321 8.71517 22.1109 9.4796 22.4233 9.69455Z"
                          stroke="black"
                          strokeMiterlimit="10"
                        />
                      </svg>
                      <svg
                        className={st.menuIconHover}
                        width="62"
                        height="30"
                        viewBox="0 0 62 30"
                        fill="black"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.3771 29L48.6229 29C55.4582 29 61 22.7317 61 14.9996C61 7.26748 55.4589 1.00001 48.6229 1.00001L13.3771 1C6.54109 1 1 7.26747 1 14.9996C0.999256 22.7317 6.54109 29 13.3771 29Z"
                          stroke="white"
                          strokeMiterlimit="10"
                        />
                        <path
                          d="M22.4233 9.69455L29.4142 14.5L22.4233 19.3054C22.1109 19.5204 21.9321 20.2848 22.0242 21.0133C22.1162 21.7418 22.4443 22.1584 22.7567 21.9434L31.4998 15.9335L40.2433 21.9434C40.5557 22.1584 40.8838 21.7418 40.9758 21.0133C41.0679 20.2848 40.8891 19.5196 40.5767 19.3055L33.5858 14.5L40.5767 9.69455C40.8891 9.4796 41.0679 8.71517 40.9758 7.9867C40.8838 7.25822 40.5557 6.84161 40.2433 7.05656L31.5002 13.0665L22.7571 7.05656C22.4447 6.84161 22.1166 7.25822 22.0246 7.98669C21.9321 8.71517 22.1109 9.4796 22.4233 9.69455Z"
                          stroke="white"
                          strokeMiterlimit="10"
                        />
                      </svg>
                    </span>
                  )}
                </button>
              </div>
              <div
                style={{ display: menuOpen ? "flex" : "none" }}
                className={cx(st.primaryMenuWraper, isSticky && st.isSticky)}
              >
                <div className={st.menuTopWrap}>
                  <div className={cx(st.primaryMenuContainer)}>
                    <ul id="primary-menu-list" className={st.menuWrapper}>
                      {header?.navigationLeft?.map((leftItem) => (
                        <li key={leftItem.id} className={st.primaryMenuItem}>
                          <Link href={leftItem.url || ""}>
                            <a href={leftItem.url || ""}>{leftItem.title}</a>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className={st.megaMenuCategoryWrap}>
                    <div className={st.megaMenuTop}>
                      <div className="search-wrap"></div>
                    </div>
                    <div id="block-16" className={st.widget}>
                      <h4>Browse by passion</h4>
                    </div>
                    <div id="block-17" className={st.widget}>
                      <div className={st.wpBlockColumns}>
                        {header?.navigationRight?.map((rightItem) => (
                          <div key={rightItem.id} className={st.wpBlockColumn}>
                            <h2>
                              <Link href={rightItem.url || ""}>
                                <a href={rightItem.url || ""} data-type="URL">
                                  {rightItem?.text}
                                </a>
                              </Link>
                            </h2>

                            <figure className={st.wpBlockImage}>
                              <Link href={rightItem.url || ""}>
                                <a href={rightItem.url || ""}>
                                  <img
                                    loading="lazy"
                                    width="397"
                                    height="397"
                                    src={rightItem?.image?.url || ""}
                                    alt={rightItem.text || ""}
                                    sizes="(max-width: 397px) 100vw, 397px"
                                  />
                                </a>
                              </Link>
                            </figure>
                          </div>
                        ))}
                      </div>
                    </div>{" "}
                  </div>
                </div>
                <div className={st.menuBottomWrap}>
                  <div className={st.menuBottomInnerWrap}>
                    <div className={st.headerBottomMenu}>
                      <div id="nav_menu-2" className={cx(st.widget)}>
                        <h2>Rockstar</h2>
                        <nav aria-label="Rockstar">
                          <ul id="menu-rockstar">
                            {footer?.rockstar?.map((item) => (
                              <li key={item.title}>
                                <a href={item.url || ""}>{item.title}</a>
                              </li>
                            ))}
                          </ul>
                        </nav>
                      </div>
                      <div id="nav_menu-3" className={cx(st.widget)}>
                        <h2>Info</h2>
                        <nav aria-label="Info">
                          <ul id="menu-info">
                            {footer?.info?.map((item) => (
                              <li key={item.title}>
                                <a href={item.url || ""}>{item.title}</a>
                              </li>
                            ))}
                          </ul>
                        </nav>
                      </div>{" "}
                    </div>
                    <div className={st.headerSocials}>
                      <div className={st.widget}>
                        <h2>Follow us</h2>
                      </div>
                      <div id="block-8" className={st.widget}>
                        <ul className={st.wpBlockSocialLinks}>
                          <li
                            className={cx(
                              st.wpSocialLink,
                              st.wpSocialLinkInstagram,
                              st.wpBlockSocialLink
                            )}
                          >
                            <a
                              href="https://www.instagram.com/rockstarenergy"
                              aria-label="Instagram: https://www.instagram.com/rockstarenergy"
                              rel="noreferrer"
                              target="_blank"
                            >
                              {" "}
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                role="img"
                                aria-hidden="true"
                                focusable="false"
                              >
                                <path d="M12,4.622c2.403,0,2.688,0.009,3.637,0.052c0.877,0.04,1.354,0.187,1.671,0.31c0.42,0.163,0.72,0.358,1.035,0.673 c0.315,0.315,0.51,0.615,0.673,1.035c0.123,0.317,0.27,0.794,0.31,1.671c0.043,0.949,0.052,1.234,0.052,3.637 s-0.009,2.688-0.052,3.637c-0.04,0.877-0.187,1.354-0.31,1.671c-0.163,0.42-0.358,0.72-0.673,1.035 c-0.315,0.315-0.615,0.51-1.035,0.673c-0.317,0.123-0.794,0.27-1.671,0.31c-0.949,0.043-1.233,0.052-3.637,0.052 s-2.688-0.009-3.637-0.052c-0.877-0.04-1.354-0.187-1.671-0.31c-0.42-0.163-0.72-0.358-1.035-0.673 c-0.315-0.315-0.51-0.615-0.673-1.035c-0.123-0.317-0.27-0.794-0.31-1.671C4.631,14.688,4.622,14.403,4.622,12 s0.009-2.688,0.052-3.637c0.04-0.877,0.187-1.354,0.31-1.671c0.163-0.42,0.358-0.72,0.673-1.035 c0.315-0.315,0.615-0.51,1.035-0.673c0.317-0.123,0.794-0.27,1.671-0.31C9.312,4.631,9.597,4.622,12,4.622 M12,3 C9.556,3,9.249,3.01,8.289,3.054C7.331,3.098,6.677,3.25,6.105,3.472C5.513,3.702,5.011,4.01,4.511,4.511 c-0.5,0.5-0.808,1.002-1.038,1.594C3.25,6.677,3.098,7.331,3.054,8.289C3.01,9.249,3,9.556,3,12c0,2.444,0.01,2.751,0.054,3.711 c0.044,0.958,0.196,1.612,0.418,2.185c0.23,0.592,0.538,1.094,1.038,1.594c0.5,0.5,1.002,0.808,1.594,1.038 c0.572,0.222,1.227,0.375,2.185,0.418C9.249,20.99,9.556,21,12,21s2.751-0.01,3.711-0.054c0.958-0.044,1.612-0.196,2.185-0.418 c0.592-0.23,1.094-0.538,1.594-1.038c0.5-0.5,0.808-1.002,1.038-1.594c0.222-0.572,0.375-1.227,0.418-2.185 C20.99,14.751,21,14.444,21,12s-0.01-2.751-0.054-3.711c-0.044-0.958-0.196-1.612-0.418-2.185c-0.23-0.592-0.538-1.094-1.038-1.594 c-0.5-0.5-1.002-0.808-1.594-1.038c-0.572-0.222-1.227-0.375-2.185-0.418C14.751,3.01,14.444,3,12,3L12,3z M12,7.378 c-2.552,0-4.622,2.069-4.622,4.622S9.448,16.622,12,16.622s4.622-2.069,4.622-4.622S14.552,7.378,12,7.378z M12,15 c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S13.657,15,12,15z M16.804,6.116c-0.596,0-1.08,0.484-1.08,1.08 s0.484,1.08,1.08,1.08c0.596,0,1.08-0.484,1.08-1.08S17.401,6.116,16.804,6.116z"></path>
                              </svg>
                            </a>
                          </li>

                          <li
                            className={cx(
                              st.wpSocialLink,
                              st.wpSocialLinkTwitter,
                              st.wpBlockSocialLink
                            )}
                          >
                            <a
                              href="https://twitter.com/rockstarenergy"
                              aria-label="Twitter: https://twitter.com/rockstarenergy"
                              rel="noreferrer"
                              target="_blank"
                            >
                              {" "}
                              <svg
                                width="1200"
                                height="1227"
                                viewBox="0 0 1200 1227"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                                  fill="white"
                                />
                              </svg>
                            </a>
                          </li>

                          <li
                            className={cx(
                              st.wpSocialLink,
                              st.wpSocialLinkFacebook,
                              st.wpBlockSocialLink
                            )}
                          >
                            <a
                              href="https://www.facebook.com/rockstar/"
                              aria-label="Facebook: https://www.facebook.com/rockstar/"
                              rel="noreferrer"
                              target="_blank"
                            >
                              {" "}
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                role="img"
                                aria-hidden="true"
                                focusable="false"
                              >
                                <path d="M12 2C6.5 2 2 6.5 2 12c0 5 3.7 9.1 8.4 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7C18.3 21.1 22 17 22 12c0-5.5-4.5-10-10-10z"></path>
                              </svg>
                            </a>
                          </li>

                          <li
                            className={cx(
                              st.wpSocialLink,
                              st.wpSocialLinkYoutube,
                              st.wpBlockSocialLink
                            )}
                          >
                            <a
                              href="https://www.youtube.com/rockstarenergy"
                              aria-label="YouTube: https://www.youtube.com/rockstarenergy"
                              rel="noreferrer"
                              target="_blank"
                            >
                              {" "}
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                role="img"
                                aria-hidden="true"
                                focusable="false"
                              >
                                <path d="M21.8,8.001c0,0-0.195-1.378-0.795-1.985c-0.76-0.797-1.613-0.801-2.004-0.847c-2.799-0.202-6.997-0.202-6.997-0.202 h-0.009c0,0-4.198,0-6.997,0.202C4.608,5.216,3.756,5.22,2.995,6.016C2.395,6.623,2.2,8.001,2.2,8.001S2,9.62,2,11.238v1.517 c0,1.618,0.2,3.237,0.2,3.237s0.195,1.378,0.795,1.985c0.761,0.797,1.76,0.771,2.205,0.855c1.6,0.153,6.8,0.201,6.8,0.201 s4.203-0.006,7.001-0.209c0.391-0.047,1.243-0.051,2.004-0.847c0.6-0.607,0.795-1.985,0.795-1.985s0.2-1.618,0.2-3.237v-1.517 C22,9.62,21.8,8.001,21.8,8.001z M9.935,14.594l-0.001-5.62l5.404,2.82L9.935,14.594z"></path>
                              </svg>
                            </a>
                          </li>

                          <li
                            className={cx(
                              st.wpSocialLink,
                              st.wpSocialLinkTiktok,
                              st.wpBlockSocialLink
                            )}
                          >
                            <a
                              href="https://www.tiktok.com/@rockstarenergy"
                              aria-label="TikTok: https://www.tiktok.com/@rockstarenergy"
                              rel="noreferrer"
                              target="_blank"
                            >
                              {" "}
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 32 32"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                role="img"
                                aria-hidden="true"
                                focusable="false"
                              >
                                <path d="M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z" />
                              </svg>
                            </a>
                          </li>
                        </ul>
                      </div>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default RockstarHeader;
